"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDiscourseItem = void 0;
const adaptivecards_1 = require("adaptivecards");
const moment_1 = __importDefault(require("moment"));
const CardHelper_1 = require("../utils/CardHelper");
function UserDiscourseItem(commentItem, contentType) {
    const itemContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {});
    const { name, comment } = commentItem;
    let text = comment;
    switch (contentType) {
        case "text/date":
            text = (0, moment_1.default)(comment).format("L");
            break;
        case "text/time":
            text = (0, moment_1.default)(comment, ["H:m"]).format("h:mm a");
            break;
    }
    const headerBlock = new adaptivecards_1.ColumnSet();
    itemContainer.addItem(headerBlock);
    const nameColumn = new adaptivecards_1.Column();
    nameColumn.width = "stretch";
    nameColumn.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
        weight: adaptivecards_1.TextWeight.Bolder,
        text: name,
        color: adaptivecards_1.TextColor.Accent,
    }));
    headerBlock.addColumn(nameColumn);
    const timestamp = CardHelper_1.CardHelper.dateTimeReplacementString(commentItem.timestamp, "COMPACT");
    const dateColumn = new adaptivecards_1.Column();
    dateColumn.width = "auto";
    dateColumn.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Right,
        text: timestamp,
        size: adaptivecards_1.TextSize.Small,
        color: adaptivecards_1.TextColor.Accent,
    }));
    headerBlock.addColumn(dateColumn);
    const commentText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `💬 ${text}`,
        wrap: true,
    });
    itemContainer.addItem(commentText);
    return itemContainer;
}
exports.UserDiscourseItem = UserDiscourseItem;
//# sourceMappingURL=UserDiscourseItem.js.map